import { Outlet } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import Banner from '@/components/banner';
import Navigation from '@/components/navbar/navigation';
import Footer from '@/components/footer';
import { Toaster } from '@/components/ui/toaster';

export default function MainLayout() {
  return (
    <Box minH={'100vh'} w='full' bgColor='secondary.500'>
      <Banner />
      <Navigation />
      <Box mt={{ md: 4 }} minHeight={'calc(100vh - 140px)'}>
        <Outlet />
        <Toaster />
      </Box>
      <Footer />
    </Box>
  );
}
